import { getPanoramas } from '@/core/api'

export default {
  namespaced: true,
  state: {
    panoramas: sessionStorage.getItem('panoramas')
      ? JSON.parse(sessionStorage.getItem('panoramas'))
      : false
  },
  mutations: {
    panoramas(state, panoramas) {
      state.panoramas = panoramas
    },
    id(state, id) {
      state.id = id
    },
    fetch(state, panoramas) {
      state.panoramas = panoramas
      sessionStorage.setItem('panoramas', JSON.stringify(panoramas))
    },
    reset(state) {
      state.panoramas = false
      sessionStorage.removeItem('panoramas')
    }
  },
  actions: {
    panoramas({ commit }, panoramas) {
      commit('panoramas', panoramas)
    },
    async fetch({ commit, state }) {
      if (state.panoramas === false) {
        const res = await getPanoramas()
        commit('fetch', res.data)
      }
    },
    reset({ commit, state }) {
      commit('reset', state)
    }
  },
  getters: {
    panoramas: state => {
      return state.panoramas
    }
  }
}
